export default __webpack_public_path__ + "static/media/spice2.782c11f9.jpg";